import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAO0lEQVR42q3OsQkAIAxE0RRqoYXgBuoWKrj/Vv7CMuly8LqDOxHPJIwvaIWMjYOiFSouFpo1MdER/Z4/5d0BxFAD/ssAAAAASUVORK5CYII="};
